import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { HttpClient } from '@angular/common/http';
import { AlcmeonContextService } from 'src/app/core/alcmeon-context/alcmeon-context.service';
import { AsyncRequestService } from 'src/app/core/async-request/async-request.service';
import { TrackService } from 'src/app/core/track/track.service';
import { Choice } from 'src/app/shared/components/select/choice.model';
import { API_URL_COMPANIES } from 'src/app/shared/services/basic.service';
import { ErrorHandlingService } from 'src/app/shared/services/error-handling.service';
import { WhatsappCloudApiMigrationWarning } from './models';
import { WhatsappCloudApiData } from './models/whatsapp-cloud-api-data.model';
import { WhatsappCloudApiLoginEventEnum } from './models/whatsapp-cloud-api-login-event.enum';
import { WhatsappCloudApiMessagingLimitEnum } from './models/whatsapp-cloud-api-messaging-limit.enum';

@Injectable({
  providedIn: 'root',
})
export class WhatsappCloudApiService {
  warnings: WhatsappCloudApiMigrationWarning[];
  /**
   * @deprecated used to log all the actions.
   */
  logs = [];

  constructor(
    private httpClient: HttpClient,
    private asyncRequestService: AsyncRequestService,
    private errorHandlingService: ErrorHandlingService,
    private alcmeonContextService: AlcmeonContextService,
    private trackService: TrackService
  ) {}

  sessionLogging(
    code: string,
    origin?: string,
    siteId?: number,
    localization?: string
  ): Observable<WhatsappCloudApiData> {
    this.logOperation('add account ', code, origin, siteId, localization);
    let url = `${API_URL_COMPANIES}/${this.alcmeonContextService.companyId}/whatsapp-cloud-api/add-account`;
    const { waba_id, phone_number_id } = this.alcmeonContextService.waCloudApiSettings.data;
    const body = {
      code,
      sessionInfo: {
        data: { waba_id, phone_number_id },
        type: 'WA_EMBEDDED_SIGNUP',
        event: WhatsappCloudApiLoginEventEnum.FINISH,
        version: this.alcmeonContextService.waCloudApiSettings.sessionInfoVersion || 2,
      },
      origin: undefined,
      data_localization_region_code: localization,
    };
    if (origin) {
      url = `${API_URL_COMPANIES}/${this.alcmeonContextService.companyId}/whatsapp-cloud-api/migrate-account/${siteId}`;
      body.origin = origin;
    }
    return this.asyncRequestService
      .post<WhatsappCloudApiData>(url, body)
      .pipe(this.errorHandlingService.catchAlertAndThrowHttpError());
  }

  flowCancelled(current_step: number) {
    const url = `${API_URL_COMPANIES}/${this.alcmeonContextService.companyId}/whatsapp-cloud-api/add-account`;
    return this.asyncRequestService
      .post<any>(url, {
        sessionInfo: {
          data: { current_step },
          type: 'WA_EMBEDDED_SIGNUP',
          event: WhatsappCloudApiLoginEventEnum.CANCEL,
          version: 2,
        },
      })
      .pipe(this.errorHandlingService.catchAlertAndThrowHttpError());
  }

  getRegions() {
    return this.httpClient
      .get<{ localization_region_codes: Choice[]; default_localization_region_code: string }>(
        `${API_URL_COMPANIES}/${this.alcmeonContextService.companyId}/whatsapp-cloud-api/local-storage/regions`
      )
      .pipe(this.errorHandlingService.catchAlertAndThrowHttpError());
  }

  getMessagingLimit(siteId: number): Observable<WhatsappCloudApiMessagingLimitEnum> {
    return this.httpClient
      .get<WhatsappCloudApiMessagingLimitEnum>(
        `${API_URL_COMPANIES}/${this.alcmeonContextService.companyId}/sites/${siteId}/whatsapp-cloud-api/messaging-limit`
      )
      .pipe(this.errorHandlingService.catchAlertAndThrowHttpError());
  }

  /**
   *
   * @deprecated
   */
  logOperation(...value: any) {
    let log: string;
    try {
      log = `${new Date().toISOString()} - ${JSON.stringify(value)}`;
      this.trackService.pushPending('whastapp-cloud-api-migration', log);
    } catch {
      log = `${new Date().toISOString()} - unable to log operation`;
    }
    (this.logs || []).push(log);
    console.error(log);
  }
}
